export const removeExtraSpaces = (value: string) => value.replace(/\s{2,}/g, ' ');

export const onlyNumbers = (value: string, maxLength = Infinity, allowDot = false) => {
  const regex = allowDot ? /[^\d.]+/g : /\D+/g;
  return value.replace(regex, '').slice(0, maxLength);
};

export const onlyLetters = (value: string, maxLength = Infinity) =>
  value
    .replace(/[^a-zA-Z\s-]+/g, '')
    .replace(/\s{2,}/g, ' ')
    .slice(0, maxLength);
